import { ReactNode } from 'react';
import { Typography } from '@mui/material';
import { Tile } from 'components/Layout/PageContainer';
import { TbIllustration, TbIllustrationProps } from 'components/Figma';

interface TradingEmptyStateProps {
  /** Primary headline shown next to the image. */
  title: ReactNode;
  /** Optional secondary description text shown below the title. */
  description?: ReactNode;
  /** Optional custom image source. Falls back to the default no-data illustration. */
  illustration?: TbIllustrationProps['name'];
  testId?: string;
}

export function TradingEmptyState({
  title,
  description = undefined,
  illustration = 'EmptyState',
  testId = undefined,
}: TradingEmptyStateProps) {
  return (
    <Tile data-testid={testId}>
      <div className="flex items-center justify-center gap-6">
        <TbIllustration name={illustration} size="xl" alt="empty-state-illustration" />
        <div className="flex flex-col gap-6">
          <Typography>
            <div className="space-y-6">
              <p>{title}</p>
              <p>{description}</p>
            </div>
          </Typography>
        </div>
      </div>
    </Tile>
  );
}
